var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3H16V1H0V3Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H14V5H2V7Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11H12V9H4V11Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H6V13H10V15Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterImg);
export default __webpack_public_path__ + "static/media/FilterImg.73952f5998a930532eba52137b37e588.svg";
export { ForwardRef as ReactComponent };